import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutStepsClientComponent } from './layout-steps-client.component';

@NgModule({
  declarations: [LayoutStepsClientComponent],
  imports: [CommonModule],
  exports: [LayoutStepsClientComponent],
})
export class LayoutStepsClientModule {}
